import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { toast } from "sonner";
import { ArrowLeft, CheckCircle2, Mail } from "lucide-react";
import PublicHeader from "../components/PublicHeader";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background bg-grain flex flex-col">
      <PublicHeader ctaTo="/login" ctaLabel="Accedi" />
      <div className="flex-1 flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="text-5xl mb-3">🍱</div>
          <h1 className="font-display text-3xl font-semibold tracking-tight mb-2">
            Password dimenticata
          </h1>
          <p className="text-sm text-muted-foreground">
            Niente paura. Te la ridiamo in 2 minuti.
          </p>
        </div>
        <div className="bg-card border border-border rounded-lg p-7 sm:p-8">
          {done ? (
            <div className="text-center py-4" data-testid="forgot-success">
              <CheckCircle2 className="w-12 h-12 text-primary mx-auto mb-3" />
              <h2 className="font-display text-xl font-medium mb-2">Controlla la tua casella</h2>
              <p className="text-sm text-muted-foreground leading-relaxed">
                Se l'indirizzo <strong className="text-foreground">{email}</strong> è registrato a Schiscetta,
                riceverai un'email con un link per scegliere una nuova password.
                <br /><br />
                Il link è valido per <strong>1 ora</strong>. Se non vedi l'email, controlla
                anche la cartella spam.
              </p>
              <Link
                to="/login"
                data-testid="forgot-back-login"
                className="inline-flex items-center gap-1.5 mt-6 text-sm text-primary hover:underline"
              >
                <ArrowLeft className="w-3.5 h-3.5" /> Torna al login
              </Link>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div className="flex items-start gap-3 p-3 bg-primary/5 border border-primary/15 rounded-md text-sm text-muted-foreground">
                <Mail className="w-4 h-4 text-primary shrink-0 mt-0.5" />
                <span>Inserisci l'email con cui ti sei registrato. Ti invieremo un link per scegliere una nuova password.</span>
              </div>
              <div>
                <label className="block text-sm font-medium mb-1.5">Email</label>
                <input
                  type="email"
                  required
                  autoComplete="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  data-testid="forgot-email-input"
                  className="w-full px-3 py-2.5 bg-white border border-border rounded-md focus:outline-none focus:ring-2 focus:ring-primary/40 focus:border-primary"
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                data-testid="forgot-submit-button"
                className="w-full py-2.5 bg-primary text-white font-medium rounded-md hover:bg-[#436343] active:scale-[0.98] disabled:opacity-50 transition-all"
              >
                {loading ? "Invio…" : "Invia link di recupero"}
              </button>
            </form>
          )}
        </div>
        <p className="text-center text-xs text-muted-foreground mt-6">
          Te la ricordi?{" "}
          <Link to="/login" className="text-primary hover:underline" data-testid="forgot-link-login">
            Torna al login
          </Link>
        </p>
      </div>
    </div>
    </div>
  );
}
